<template>
<section class="mx-2">
    <h3>Finished Goods</h3>
    <b-table :items="finished.items" :fields="finished.fields" class="mb-4">
      <template slot="avgcost" slot-scope="data">
        {{ data.item.avgcost | formatDollars }}
        <div v-if="isAvgSumInaccurate()" class="ml small">($0 parts listed below)</div>
      </template>
      <template slot="fifocost" slot-scope="data">
        {{ data.item.fifosum | formatDollars }}
        <div v-if="isFifoSumInaccurate()" class="ml small">($0 parts listed below)</div>
      </template>
      <template slot="prodprice" slot-scope="data">
        {{ data.item.prodprice | formatDollars }}
      </template>
      <template slot="prodsum" slot-scope="data">
        {{ data.item.prodsum | formatDollars }}
      </template>
      <template slot="qtyonhand" slot-scope="data">
        {{ Number(data.item.qtyonhand) }}
      </template>
    </b-table>
    <h3>Raw Material(s)</h3>
    <b-table :items="raw.items" :fields="raw.fields" class="my-2">
      <template slot="itemtype" slot-scope="data">
        {{ data.item.typename }} <br /> -{{ data.item.parttypename }}
        <br>
        <router-link target="_blank" :to="{ name: 'BOM KIT Info', query: {bomKitNumber: data.item.bomitemnum} }">Dig In</router-link>
      </template>
      <template slot="avgcost" slot-scope="data">
        {{ data.item.avgcost | formatDollars }}
      </template>
      <template slot="fifocost" slot-scope="data">
        {{ data.item.fifocost | formatDollars }}
      </template>
      <template slot="prodprice" slot-scope="data">
        {{ data.item.prodprice | formatDollars }}
      </template>
      <template slot="quantity" slot-scope="data">
        {{ Number(data.item.quantity) }}
      </template>
      <template slot="qtyonhand" slot-scope="data">
        {{ Number(data.item.qtyonhand) }}
      </template>
      <template slot="qtynotavailabletopick" slot-scope="data">
        {{ Number(data.item.qtynotavailabletopick) }}
      </template>
      <template slot="locations" slot-scope="data">
        <div v-for="loc in (data.item.locations || '').split('\n')">{{loc}}</div>
      </template>
    </b-table>
</section>
</template>

<script>
import axios from 'axios';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    alert: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      finished: {
        items: [],
        fields: [
          { key: 'bomitemnum', label: 'BOM Number', sortable: true },
          { key: 'bomitemdescription', label: 'BOM Description', sortable: true },
          { key: 'quantity', label: 'Quantity Created by BOM', sortable: true },
          { key: 'avgcost', label: 'Est. Avg. Cost', sortable: true },
          { key: 'fifocost', label: 'Raw Material FIFO Costs', sortable: true },
          { key: 'prodprice', label: 'Product Price', sortable: true },
          { key: 'prodsum', label: 'Component Price Sum', sortable: true },
          { key: 'qtyonhand', label: 'Qty on Shelf', sortable: true },
          { key: 'locations', label: 'Location', sortable: true },
          { key: 'qtyallocated', label: 'Total Qty Allocated', sortable: true },
          { key: 'qtyallocatedmo', label: 'Qty Allocated in MOs', sortable: true },
          { key: 'qtynotavailabletopick', label: 'Qty in Non-Pickable Location', sortable: true },
          { key: 'minbuild', label: 'Qty Able to Build', sortable: true },
          { key: 'bomnote', label: 'BOM Note', sortable: true },
          { key: 'availableandbuild', label: 'Total Available PLUS Can Build', sortable: true },
        ],
      },
      raw: {
        items: [],
          fields: [
          { key: 'itemtype', label: 'Item Type', sortable: true },
          { key: 'bomitemnum', label: 'Item Num', sortable: true },
          { key: 'bomitemdescription', label: 'Item Description', sortable: true },
          { key: 'minqty', label: 'Min Qty', sortable: true },
          { key: 'maxqty', label: 'Max Qty', sortable: true },
          { key: 'quantity', label: 'Quantity', sortable: true },
          { key: 'avgcost', label: 'Est. Avg. Cost', sortable: true },
          { key: 'fifocost', label: 'FIFO Cost', sortable: true },
          { key: 'prodprice', label: 'Products Price Subtotal', sortable: true },
          { key: 'qtyonhand', label: 'Qty on Shelf', sortable: true },
          { key: 'locations', label: 'Locations', sortable: true },
          { key: 'qtyallocated', label: 'Total Qty Allocated', sortable: true },
          { key: 'qtyallocatedmo', label: 'Qty Allocated in MOs', sortable: true },
          { key: 'qtynotavailabletopick', label: 'Qty in Non-Pickable Locations', sortable: true },
          { key: 'openpodata', label: 'PO Info', sortable: true },
          { key: 'abletobuild', label: 'Finished Goods Able to Build', sortable: true },
        ],
      },
    }
  },
  mounted() {
    axios.get(`${BASE_API}/fishbowl/bom/${this.item.bomid}`).then((response) => {
      response.data.forEach((data) => {
        let qtyhave = Number(data.qtyonhand)
          - Number(data.qtyallocated)
          - Number(data.qtynotavailabletopick);
        data.abletobuild = Number(data.quantity) > 0 ? Math.floor(qtyhave
        * Number(data.conversionfactor) / Number(data.conversionmultiply)
          / Number(data.quantity)) : 0;
        if (data.bomitemtypeid == 10) {
          this.finished.items.push(data);
        } else {
          data._cellVariants = {
            avgcost: this.highlightZeroes(data.avgcost),
            fifocost: this.highlightZeroes(data.fifocost),
            prodprice: this.highlightNines(data.prodprice),
            abletobuild: this.highlightNumbers(data.abletobuild)
          }
          this.raw.items.push(data);
        }
      });
      let minbuild = Math.min.apply(null, this.raw.items.filter(item => item.parttypeid = 10).map(item => item.abletobuild));
      this.finished.items.forEach((item) => {
        item.minbuild = minbuild;
        item.availableandbuild = item.abletobuild + minbuild;
        item.prodsum = this.raw.items.map( i => Number(i.prodprice) * i.quantity).reduce( (a, v) => v + a, 0) / item.quantity;
        item.fifosum = this.raw.items.map( i => (Number(i.fifocost) || 0) * i.quantity).reduce( (i,a) => Number(i) + Number(a), 0) / item.quantity;
        console.log(this.raw.items.map(i => (Number(i.avgcost) || 0) * i.quantity), this.raw.items.map(i => (Number(i.avgcost) || 0) * i.quantity).reduce((m,i)=>m+i),0)
        item._cellVariants = {
          availableandbuild: this.highlightNumbers(item.availableandbuild),
          avgcost: this.isAvgSumInaccurate() ? 'tomato' : '',
          fifocost: this.isFifoSumInaccurate() ? 'tomato' : ''
        };
      })
    }).catch((error) => {
      console.error(error);
      this.alert.variant = 'danger';
      this.alert.message = 'Failed to fetch kit. See console for more information.';
    });
  },
  methods: {
    highlightNumbers(number) {
      if (number == 0) return 'red';
      else if (number < 5) return 'orangered';
      else if (number < 10) return 'palevioletred';
      else if (number < 15) return 'pink';
      else if (number < 25) return 'orange';
      else if (number < 40) return 'yellow';
      else if (number < 50) return '';
      else if (number == '0-See This Kit') return 'lightblue';
      else return 'lightgreen';
    },
    highlightZeroes(number) {
      if (number == null || number == 0) return 'tomato';
    },
    highlightNines(number) {
      let regex = RegExp(/9{3,}/g);
      if (isNaN(number) || regex.exec(Math.round(number))) return 'tomato';
    },
    isFifoSumInaccurate() {
      return this.raw.items.some(i => !i.fifocost || i.fifocost == 0)
    },
    isAvgSumInaccurate() {
      return this.raw.items.some(i => !i.avgcost || i.avgcost == 0)
    }
  },
}
</script>

<style>
.table-red { background-color: red; }
.table-tomato { background-color: tomato; }
.table-orangered { background-color: orangered; }
.table-palevioletred { background-color: palevioletred; }
.table-pink { background-color: pink; }
.table-orange { background-color: orange; }
.table-yellow { background-color: yellow; }
.table-lightblue { background-color: lightblue; }
.table-lightgreen { background-color: lightgreen; }
</style>



// WEBPACK FOOTER //
// src/components/inventory/BomInfo.vue